import store from '../store'

export default {
  data () {
    return {
      appConfigs: store.getters.appConfig
    }
  },
  methods: {
    getImage (file, external = false) {
      if (external) {
        return file
      } else {
        return require(`../assets/client/${process.env.CLIENTID}/images/${file}`)
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/brandingMixin.js